"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RANGE_SLIDER_VALUES = void 0;
var RANGE_SLIDER_VALUES = {
  MIN: 1,
  MAX: 100,
  DEFAULT_VALUE: 50
};
exports.RANGE_SLIDER_VALUES = RANGE_SLIDER_VALUES;